import { IEmailPreferenceGroup } from '@faire/web-api--source/com/faire/email/preferences/IEmailPreferenceGroup';
import { IEmailPreferencesEmailAddress } from '@faire/web-api--source/com/faire/email/preferences/IEmailPreferencesEmailAddress';
import { IEmailPreferenceSubgroup } from '@faire/web-api--source/com/faire/email/preferences/IEmailPreferenceSubgroup';
import { UnsubscribedMarketingType } from '@faire/web-api--source/indigofair/data/UnsubscribedMarketingType';

export namespace IGetEmailPreferencesResponse {
  /**
   * Return an instance of IGetEmailPreferencesResponse with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IGetEmailPreferencesResponse>
  ): IGetEmailPreferencesResponse =>
    ({
      email_preference_groups: [],
      available_email_addresses: [],
      unsubscribed_marketing_types: [],
      ...(partial ?? {}),
    }) as IGetEmailPreferencesResponse;
}

export interface IGetEmailPreferencesResponse {
  /**
   * email to display, might change if user is logged in or out
   */
  email_address_to_display: string | undefined;
  /**
   * is this user unsubscribed from all emails
   */
  is_unsubscribed_from_all: boolean | undefined;
  /**
   * current email preferences
   */
  email_preference_groups: Array<IEmailPreferenceGroup>;
  /**
   * The email sub-group to unsubscribe from
   */
  confirm_unsubscribe_from_subgroup: IEmailPreferenceSubgroup | undefined;
  /**
   * Available email addresses in the current context
   */
  available_email_addresses: Array<IEmailPreferencesEmailAddress>;
  /**
   * Unsubscribed from marketing types
   */
  unsubscribed_marketing_types: Array<keyof typeof UnsubscribedMarketingType>;
}
